import axios from 'axios'

const updateUse = async (id, userData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/updateUser/${id}`,
      userData,
      {
        withCredentials: true,
      }
    )
    console.log('resss ', response.data)
    return response.data
  } catch (error) {
    throw error
  }
}

export default updateUse
